import { invariant } from '../util/invariant';
export class Attribute {
    constructor(name, optional, valueSchema, valueSchemaLocation, isPattern) {
        this.name = name;
        this.optional = optional;
        this.valueSchema = valueSchema;
        this.valueSchemaLocation = valueSchemaLocation;
        this.isPattern = isPattern;
    }
    withValueSchemaLocation(valueSchemaLocation) {
        return new Attribute(this.name, this.optional, this.valueSchema, valueSchemaLocation, this.isPattern);
    }
    canCombine(other) {
        return this.name === other.name && this.isPattern === other.isPattern;
    }
    combine(other) {
        invariant(this.canCombine(other));
        const optional = other.optional && this.optional;
        const valueSchema = other.valueSchema; // FIXME: track all combined schemas
        const valueSchemaLocation = other.valueSchemaLocation; // FIXME: track all combined schemas
        return new Attribute(this.name, optional, valueSchema, valueSchemaLocation, this.isPattern);
    }
}
